import { NgModule } from "@angular/core";
import { LayoutModule, SharedModule } from "@app/shared";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { TableModule } from "primeng/table";
import { OtherDocumentsComponent } from "./other-documents.component";
import { RouterModule } from "@angular/router";
import { LeadLifecycleReusableComponentsModule } from "../../lead-header/lead-lifecycle-reusable-components.module";
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';

@NgModule({
    declarations: [OtherDocumentsComponent],
    imports: [
        SharedModule, ScrollPanelModule, TableModule, CalendarModule, DropdownModule,
        LayoutModule,
        LeadLifecycleReusableComponentsModule,
        RouterModule.forChild([
            { path: '', component: OtherDocumentsComponent, data: { title: 'Other Documents' }, canActivate: [AuthGuard] },
        ])
    ],
    exports: [OtherDocumentsComponent]
})
export class OtherDocumentsModule { }